import React from 'react'
import bg from './images/as_airdrop_bg.png'
export const AirDrop = () => {
  return (
    <div style={{overflow: 'hidden'}}>
      <img style={{width: '100%',float: 'left'}} src={bg}/>
    </div>
  )
}
